// 🔧 ticket_seeder.js
// ✅ Purpose: Seeds Ticket Engine demo data into Firestore
// ✅ Features:
// - Coordinates persistence of ticket types and ticket records
// - Calls repository layer only
// - No Firestore logic here
// - Returns standardized results to Builder
// - Fully block-commented for clarity and future devs

import { saveTicketData } from "./ticket_repository";

export const seedTickets = async ({
  demoContext,
  ticketPlan,
} = {}) => {
  console.log("🌱 Ticket Seeder started.");

  if (!ticketPlan) {
    throw new Error("Ticket Seeder requires ticketPlan.");
  }

  const results = await saveTicketData({
    demoContext,
    ticketTypes: ticketPlan.ticketTypes || [],
    tickets: ticketPlan.tickets || [],
  });

  console.log("✅ Ticket Seeder completed.", {
    ticketTypes: results.ticketTypes.length,
    tickets: results.tickets.length,
  });

  return results;
};